const subscriptionDetailState = (function states(props) {
    return {
        labelList: [],
    }
})()

export default subscriptionDetailState;